import { getThemeColor, Spacer } from '@sparemin/blockhead';
import styled from 'styled-components';

export const Container = styled(Spacer)`
  color: ${getThemeColor('d1')};
  text-align: center;
  padding: 0 20px;
  align-items: center;
`;
